$(document).ready(function () {
  // $(".category_name").each(function () {
  //   var title = $(this).text().trim(); // Get the text inside the div and trim any whitespace
  //   var words = title.split(" "); // Split the title into an array of words

  //   if (words.length > 3) {
  //     // If the title contains more than 2 words, truncate it and add "..."
  //     var truncatedTitle = words.slice(0, 3).join(" ") + "...";
  //     $(this).text(truncatedTitle);
  //   }
  // });

  var lastScrollTop = 0; // Variable to track scroll position

  // Initial interval for checking categories-load-icon
  var timout = setInterval(function () {
    if ($(".categories-load-icon").length > 0) {
      $(".categories-load-icon").removeClass("categories-load-iconing");
      clearInterval(timout);
    }
  }, 600);

  function lazyLoadIcons() {
    const lazyImages = $(".lazy-load-icon img:not(.loaded)"); // Only select images not yet loaded

    lazyImages.each(function () {
      const img = $(this);

      // Check if the image is in view and not already loaded
      if (isElementInView(img) && !img.hasClass("loaded")) {
        // Add loader animation to the div containing the image
        img
          .closest(".categories-load-icon")
          .addClass("categories-load-iconing");

        // Simulate a delay for loading
        setTimeout(function () {
          // Load the image from data-src and mark it as loaded
          img.attr("src", img.data("src")).addClass("loaded");

          // Remove loader after image has been loaded
          img
            .closest(".categories-load-icon")
            .removeClass("categories-load-iconing");
        }, 600); // 1500ms delay to remove the loader
      }
    });
  }

  // Helper function to check if the element is in view
  function isElementInView(element) {
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();
    var elementTop = element.offset().top;
    var elementBottom = elementTop + element.height();

    return elementBottom >= windowTop && elementTop <= windowBottom;
  }

  // Trigger lazy load on page load
  lazyLoadIcons();

  // Detect scroll event
  $(window).on("scroll", function () {
    var st = $(this).scrollTop(); // Get current scroll position

    // Only trigger lazy load when scrolling down
    if (st > lastScrollTop) {
      lazyLoadIcons(); // Call lazy load function on scroll down
    }

    lastScrollTop = st; // Update last scroll position
  });
});
